// Per-tick user command, like Source's CUserCmd.

export const IN_ATTACK = 1 << 0;
export const IN_JUMP = 1 << 1;
export const IN_DUCK = 1 << 2;
export const IN_FORWARD = 1 << 3;
export const IN_BACK = 1 << 4;
export const IN_USE = 1 << 5;
export const IN_MOVELEFT = 1 << 9;
export const IN_MOVERIGHT = 1 << 10;
export const IN_ATTACK2 = 1 << 11;
export const IN_RELOAD = 1 << 13;

export interface UserCmd {
  /** cl_forwardspeed units, positive = forward. Clamped to maxspeed by movement. */
  forwardmove: number;
  /** cl_sidespeed units, positive = right (Source convention). */
  sidemove: number;
  buttons: number;
  /**
   * View yaw in radians, Source convention: 0 looks down +X, positive turns left (toward +Y).
   * Radians rather than Source's degrees so the math is bit-identical to the prototype.
   */
  yaw: number;
  /** View pitch in radians, Source convention: positive looks down. Movement ignores it. */
  pitch: number;
  /** Weapon switch this tick: 0 none, 1 knife, 2 USP, 3 the other one. */
  weaponSelect: number;
}

export function createCmd(): UserCmd {
  return { forwardmove: 0, sidemove: 0, buttons: 0, yaw: 0, pitch: 0, weaponSelect: 0 };
}

export function copyCmd(out: UserCmd, c: Readonly<UserCmd>): UserCmd {
  out.forwardmove = c.forwardmove;
  out.sidemove = c.sidemove;
  out.buttons = c.buttons;
  out.yaw = c.yaw;
  out.pitch = c.pitch;
  out.weaponSelect = c.weaponSelect;
  return out;
}
